module.exports = __webpack_public_path__ + "static/media/green_car.e88dec4c.png";